"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _QuestionsActions = require("./QuestionsActions");

var initialState = {
  questions: [],
  error: null,
  loading: false,
  latestAddedQuestion: null,
  lastSave: null,
  lastReorderedQuestionId: null
};

var QuestionsReducer = function QuestionsReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case _QuestionsActions.LOAD_QUESTION:
      return (0, _extends2["default"])({}, state, {
        loading: action.payload
      });

    case _QuestionsActions.LOAD_QUESTIONS_SUCCESS:
      return (0, _extends2["default"])({}, state, {
        questions: action.payload,
        error: null,
        loading: false,
        latestAddedQuestion: null
      });

    case _QuestionsActions.LOAD_QUESTIONS_ERROR:
    case _QuestionsActions.NEW_QUESTION_ERROR:
    case _QuestionsActions.UPDATE_QUESTION_ERROR:
    case _QuestionsActions.DELETE_QUESTION_ERROR:
    case _QuestionsActions.UPDATE_QUESTION_POSITIONS:
      return (0, _extends2["default"])({}, state, {
        questions: action.payload
      });

    case _QuestionsActions.REORDER_LAST_QUESTION:
      return (0, _extends2["default"])({}, state, {
        lastReorderedQuestionId: action.payload
      });

    case _QuestionsActions.REORDER_QUESTIONS_ERROR:
      return (0, _extends2["default"])({}, state, {
        error: action.payload,
        loading: false
      });

    case _QuestionsActions.NEW_QUESTION:
      return (0, _extends2["default"])({}, state, {
        questions: [].concat(state.questions, [action.payload]),
        latestAddedQuestion: action.latestAddedQuestion,
        lastSave: action.lastSavePayload,
        loading: false
      });

    case _QuestionsActions.UPDATE_QUESTION_LOAD:
    case _QuestionsActions.DELETE_QUESTION_LOAD:
    case _QuestionsActions.NEW_QUESTION_LOAD:
      return (0, _extends2["default"])({}, state, {
        loading: action.payload
      });

    case _QuestionsActions.UPDATE_QUESTION:
      return (0, _extends2["default"])({}, state, {
        loading: false,
        // eslint-disable-next-line
        questions: state.questions.map(function (question) {
          return question.id === action.payload.id // eslint-disable-next-line
          ? question = action.payload : question;
        }),
        latestAddedQuestion: action.payload,
        lastSave: action.lastSavePayload
      });

    case _QuestionsActions.DELETE_QUESTION:
      return (0, _extends2["default"])({}, state, {
        questions: state.questions.filter(function (question) {
          return question.id !== action.payload.id;
        }),
        lastSave: action.lastSavePayload,
        loading: false
      });

    default:
      return state;
  }
};

var _default = exports["default"] = QuestionsReducer;